var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-tooltip',{attrs:{"effect":"dark","content":_vm.description,"placement":"right","disabled":!_vm.description}},[_c('span',[_vm._v(_vm._s(_vm.title))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }